<template lang="pug">
  e-form-group(
  inputType="suggestion"
  :name="showedName"
  label="Юридические лица"
  :model="fields"
  :tabView="tabView"
  :formGroupStyle="formGroupStyle"
  :required="required"
  :suggestionEndpoint="suggestionEndpoint"
  :transformSuggestions="transformSuggestions"
  @selectItem="selectItem"
  :minSuggestLen="2"
  )
</template>
<script>
  import reportFieldMixin from '../../mixins/report-field-mixin'
  import {wasteGenerators} from "../../../../api/api-endpoints"

  export default {
    mixins: [reportFieldMixin],
    name: 'legals',
    created () {
      this.$set(this.fields, this.fieldName, '')
    },
    computed: {
      fieldName () {
        return 'legal'
      },
      showedName () {
        return `_${this.fieldName}_name`
      }
    },
    methods: {
      selectItem ($event) {
        if ($event && $event.id) {
          let copy = JSON.parse(JSON.stringify($event))
          this.$set(this.fields, this.fieldName, copy.id)
          this.$set(this.fields, this.showedName, copy.name)
        } else {
          this.$set(this.fields, this.fieldName, '')
          this.$set(this.fields, this.showedName, '')
        }
      },
      suggestionEndpoint (ctx, q) {
        return wasteGenerators.legals({query: {q, 'per-page': 50}})
      },
      transformSuggestions (ctx, data) {
        return data.data.map(({id, full_name}) => ({id, name: full_name}))
      }
    }
  }
</script>
